document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(
    ".ck-image-with-text__media-slider .ck-slider-image"
  );
  const total = slides.length;

  if (total === 0) return;

  if (total === 1) {
    slides[0].style.opacity = "1";
    slides[0].style.position = "relative";
    slides[0].style.inset = "0";
    slides[0].style.pointerEvents = "auto";
    return;
  }

  let current = 0;
  const interval = 5000;
  const fadeDuration = 1000;

  slides.forEach((slide, index) => {
    slide.style.opacity = index === 0 ? "1" : "0";
    slide.style.transition = `opacity ${fadeDuration}ms ease-in-out`;
    slide.style.position = "absolute";
    slide.style.inset = "0";
    slide.style.pointerEvents = "none";
  });

  setInterval(() => {
    const next = (current + 1) % total;
    slides[current].style.opacity = "0";
    slides[next].style.opacity = "1";
    current = next;
  }, interval);
});
